import 'css-chunksrc/client/scenes/projectResourceDeactivation/styles.scss';export default {
  "body": "_body_1oulk_1",
  "footer": "_footer_1oulk_8",
  "warning": "_warning_1oulk_17",
  "group": "_group_1oulk_23"
};